import { route, tag, type PageTour } from '../pageTour';

export const turnMonitorTour: PageTour = {
  id: 'page-turn-monitor',
  version: 1,
  title: 'TURN Server',
  summary: 'The relay server that carries live video to remote viewers.',
  match: route('/turn-monitor'),
  steps: [
    {
      target: tag('turn-status'),
      title: 'Is the relay running?',
      description:
        'The TURN server is the relay that carries live video when a direct connection between a viewer and a site isn’t possible. Green means it is up and ready.',
      side: 'bottom',
    },
    {
      target: tag('turn-load'),
      title: 'Current relay load',
      description:
        'How much video is flowing through the relay right now. “Idle” simply means every viewer is connected directly, or nobody is watching.',
      side: 'bottom',
    },
    {
      target: tag('turn-summary'),
      title: 'Key numbers',
      description:
        'Viewers being relayed, bandwidth in and out, the busiest it has ever been, and errors. Rising errors usually mean viewers are struggling to connect.',
      side: 'bottom',
    },
    {
      target: tag('turn-history'),
      title: 'Metrics history',
      description: 'See how relay traffic has changed over time, to spot peak hours or a sudden spike.',
      side: 'top',
    },
    {
      target: tag('turn-range'),
      title: 'Choose a time range',
      description: 'Switch the chart between the last 30 minutes and the last 24 hours.',
      side: 'left',
    },
  ],
};
